import { InjectionToken } from "@angular/core";

import { ConfigService } from "./config.service";

export const CONFIG_SERVICE_TOKEN = new InjectionToken<ConfigService<any>>("CONFIG_SERVICE");

export const CONFIG_ERROR_ATLAS = {
	missingValue: "E_CONFIG_SERVICE_MISSING_VALUE",
	defaultValueRequired: "E_CONFIG_SERVICE_DEFAULT_VALUE_REQUIRED",
	missingTenant: "E_CONFIG_SERVICE_MISSING_TENANT",
	duplicateExperiment: "W_CONFIG_SERVICE_DUPLICATE_EXPERIMENT",
};
